import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Col, Form, Input, Row, message } from "antd";
import login_logo from "../../assets/logo.svg";
import userService from "../../services/userService.js";
import "../Signup/signup.scss";
import { BsCheckLg } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { store } from "../../Components/Redux/store.js";
import { setInstructionTrue } from "../../Components/Redux/actions.js";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const ROOT = `auth_module`;
  const initialValues = {
    password: "",
    confirmPassword: "",
  };
  const [userDetails, setUserDetails] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    verifyUserLink();
  }, [token]);

  const verifyUserLink = async () => {
    if (token) {
      try {
        const verifyUser = await userService.verifyResetPassword(token);
        console.log("verify", verifyUser);
        if (verifyUser.error) {
          message.destroy();
          message.error(
            verifyUser?.error?.message || "Something went worng in verifing"
          );
        } else {
          message.destroy();
          // message.success(verifyUser?.message || "Successfully verified");
          setUserDetails(verifyUser?.data);
        }
      } catch (error) {
        navigate("/login");
        return;
      }
    }
  };

  const onFinish = async (values) => {
    // console.log('Received values of form: ', values)
    let formData = values;
    formData.token = token;
    formData.purpose = "signup";
    // console.log(formData)
    if (formData.password && formData.confirmPassword && formData.token) {
      setSubmitted(true);
      try {
        const response = await userService.signUpPassword(formData);

        if (response.error) {
          message.destroy();
          message.error(
            response?.error?.message ||
              "Something went worng in setting new password"
          );
          navigate("/login");
        } else {
          message.destroy();
          message.success("Password set successfully");
          navigate("/login");
          store.dispatch(setInstructionTrue(true));
        }
      } catch (error) {
        navigate("/login");
      }
      setSubmitted(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // checking password and confirm password matched or not for button disable
  const [passMatched, setPassMatched] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmassword, setConfirmPassword] = useState("");
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [hasMinLength, setHasMinLength] = useState(false);

  const isValidPassword = (password) => {
    const upperCase = /[A-Z]/.test(password);
    const lowerCase = /[a-z]/.test(password);
    const number = /\d/.test(password);
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const minLength = password.length >= 8;

    setHasUpperCase(upperCase);
    setHasLowerCase(lowerCase);
    setHasNumber(number);
    setHasSpecialChar(specialChar);
    setHasMinLength(minLength);
    if (upperCase && lowerCase && number && specialChar && minLength) {
      setPassword(password);
    }
  };
  useEffect(() => {
    if (password && confirmassword) {
      if (password === confirmassword) {
        setPassMatched(false);
      } else {
        setPassMatched(true);
      }
    }
  }, [password, confirmassword, passMatched]);

  return (
    <div className={`${ROOT}__auth`} align="middle">
      <Row style={{ height: "100vh" }}>
        <Col lg={8} className="m-auto">
          <Card className={`${ROOT}__pass`}>
            <div className="text-center">
              <img alt="user" src={login_logo} />
            </div>
            <h5></h5>
            <h5>Please set your password</h5>
            <h6 className="mb-3">{userDetails?.email}</h6>
            <Form
              layout="vertical"
              name="set-password"
              className="login-form"
              initialValues={initialValues}
              onFinish={(e) => onFinish(e)}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="password"
                label="Create New Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your Password!",
                  },
                ]}
              >
                {/* <label>Create New Password</label> */}
                <Input.Password
                  placeholder="Enter New Password"
                  size="large"
                  onChange={(e) => isValidPassword(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Password do not match!")
                      );
                    },
                  }),
                ]}
              >
                {/* <label>Confirm Password</label> */}
                <Input.Password
                  placeholder="Confirm Password"
                  size="large"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </Form.Item>
              <Col className="validation-text text-start my-3">
                <h6>Password must contain the following:</h6>
                <ul>
                  <li>
                    <span>
                      {hasUpperCase ? (
                        <BsCheckLg className="check-icon" />
                      ) : (
                        <RxCross2 className="cross-icon" />
                      )}
                    </span>
                    <span
                      className={`${
                        hasUpperCase ? "valid-text" : "invalidText"
                      }`}
                    >
                      Contain one uppercase letter
                    </span>
                  </li>

                  <li>
                    <span>
                      {hasLowerCase ? (
                        <BsCheckLg className="check-icon" />
                      ) : (
                        <RxCross2 className="cross-icon" />
                      )}
                    </span>
                    <span
                      className={`${
                        hasLowerCase ? "valid-text" : "invalidText"
                      }`}
                    >
                      Contain one lowercase letter
                    </span>
                  </li>

                  <li>
                    <span>
                      {hasNumber ? (
                        <BsCheckLg className="check-icon" />
                      ) : (
                        <RxCross2 className="cross-icon" />
                      )}
                    </span>
                    <span
                      className={`${hasNumber ? "valid-text" : "invalidText"}`}
                    >
                      Contains one number
                    </span>
                  </li>

                  <li>
                    <span>
                      {hasSpecialChar ? (
                        <BsCheckLg className="check-icon" />
                      ) : (
                        <RxCross2 className="cross-icon" />
                      )}
                    </span>
                    <span
                      className={`${
                        hasSpecialChar ? "valid-text" : "invalidText"
                      }`}
                    >
                      Contain one speacial character (@, #, $, %, etc)
                    </span>
                  </li>
                  <li>
                    <span>
                      {hasMinLength ? (
                        <BsCheckLg className="check-icon" />
                      ) : (
                        <RxCross2 className="cross-icon" />
                      )}
                    </span>
                    <span
                      className={`${
                        hasMinLength ? "valid-text" : "invalidText"
                      }`}
                    >
                      At least 8 characters
                    </span>
                  </li>
                </ul>
              </Col>

              <Form.Item className="mb-0">
                <Button
                  block
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  disabled={passMatched || submitted}
                >
                  Set your Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default VerifyEmail;
